"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellGridInfoManager = void 0;
var grid_maker_1 = require("../../../model/tables/grid/grid-maker");
var CellGridInfoManager = (function () {
    function CellGridInfoManager(table) {
        this.tableCellGridInfos = [];
        this.tableCellInfos = [];
        grid_maker_1.GridMaker.fillGridInfo(table, this.tableCellGridInfos, this.tableCellInfos);
    }
    CellGridInfoManager.prototype.gridInfosByTablePosition = function (tblPos) {
        return this.tableCellInfos[tblPos.rowIndex][tblPos.cellIndex];
    };
    return CellGridInfoManager;
}());
exports.CellGridInfoManager = CellGridInfoManager;
